import { Link } from "react-router-dom";

interface NavbarProps {
  onlyLogo?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ onlyLogo }) => {

  const Logo = "/documents/d/guest/Frame";

  return (
    <div
      data-animation="default"
      data-collapse="medium"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className="menu is-transparente w-nav"
    >
      <div className="menu_cont">
        <a href={"/"} className="menu_link-logo w-nav-brand">
          <img
            src={Logo}
            loading="lazy"
            alt=""
            className="menu_logo is-cortado _2btns"
          />
        </a>
        {!onlyLogo &&
          <nav role="navigation" className="menu_links is-cortado w-nav-menu">
            <a className="menu_item w-nav-link">
              ¿No tienes cuenta?
            </a>
            <Link to="/quiero-registrarme/registro-dni" className="button-overlay is-main is-celeste w-button">
              Quiero registrarme
            </Link>
          </nav>}
      </div>
    </div>
  );
};

export default Navbar;
